module.exports = __webpack_public_path__ + "static/media/ios-podium.35444e01.svg";